import { render, staticRenderFns } from "./PlanoItem.vue?vue&type=template&id=32b32326&scoped=true"
import script from "./PlanoItem.vue?vue&type=script&lang=js"
export * from "./PlanoItem.vue?vue&type=script&lang=js"
import style0 from "./PlanoItem.vue?vue&type=style&index=0&id=32b32326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b32326",
  null
  
)

export default component.exports